import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

// Embedded-iframe auth (e.g. Salesforce softphone): when third-party cookies are
// blocked, a first-party bridge popup supplies a token we send as a Bearer header.
const BRIDGE_TOKEN_KEY = "inspiro_bridge_token";
export function setBridgeToken(t) {
    try {
        if (t) sessionStorage.setItem(BRIDGE_TOKEN_KEY, t);
        else sessionStorage.removeItem(BRIDGE_TOKEN_KEY);
    } catch (_e) { /* ignore */ }
}
export function getBridgeToken() {
    try { return sessionStorage.getItem(BRIDGE_TOKEN_KEY) || ""; } catch (_e) { return ""; }
}
api.interceptors.request.use((config) => {
    const t = getBridgeToken();
    if (t) config.headers = { ...(config.headers || {}), Authorization: `Bearer ${t}` };
    return config;
});

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
